

import { useTranslation } from "react-i18next";
import ReactDOM from 'react-dom/client';

import { Link as LinkScroll, animateScroll as scroll, scroller } from "react-scroll";

import React, { useState, useEffect, useRef } from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useLocation,
    useNavigate
} from "react-router-dom";

import productImg from '../../assets/product.png'

import bannerImg from '../../assets/home/banner.jpg'

import bg1Img from '../../assets/home/1.jpg'
import bg2Img from '../../assets/home/2.jpg'
import bg3Img from '../../assets/home/3.jpg'
import bg4Img from '../../assets/home/4.jpg'



import logoImg from '../../assets/logo.png'
import bannerLogoImg from '../../assets/home/bannerlogo.png'



import { separatorNumber, useGlobalFunc } from "../../global/constants.js";
import UserApi from "../../services/UserApi";
import { useSelector } from "react-redux";



const Home = () => {
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate()
    const query = new URLSearchParams(location.search);

    const menuData = useSelector(state => state.menu);

    const { setLoading, successToast, errorToast } = useGlobalFunc()



    const pageContent = [

        {
            title: "SKIN CARE",
            content: "青山依舊在，幾度夕陽紅。白髮漁樵江渚上，慣看秋月春風。 一壺濁酒喜相逢。青山依舊在，幾度夕陽紅。白髮漁樵江渚上，慣看秋月春風。一壺濁酒喜相逢。",
            path: "",
            color: "text-[#E0836F]",
        },
        {
            title: "HEALTHY CARE",
            content: "青山依舊在，幾度夕陽紅。白髮漁樵江渚上，慣看秋月春風。 一壺濁酒喜相逢。青山依舊在，幾度夕陽紅。白髮漁樵江渚上，慣看秋月春風。一壺濁酒喜相逢。",
            path: "",
            color: "text-[#8FB09F]",
        },
        {
            title: "MED CARE",
            content: "青山依舊在，幾度夕陽紅。白髮漁樵江渚上，慣看秋月春風。 一壺濁酒喜相逢。青山依舊在，幾度夕陽紅。白髮漁樵江渚上，慣看秋月春風。一壺濁酒喜相逢。",
            path: "",
            color: "text-[#7E9CAF]",
        },
        {
            title: "PET CARE",
            content: "青山依舊在，幾度夕陽紅。白髮漁樵江渚上，慣看秋月春風。 一壺濁酒喜相逢。青山依舊在，幾度夕陽紅。白髮漁樵江渚上，慣看秋月春風。一壺濁酒喜相逢。",
            path: "",
            color: "text-[#E2A52B]",
        }
    ]

    const [totalPage, setTotalPage] = useState(1);
    const [page, setPage] = useState(1);
    const handleChange = (event, value) => {
        setPage(value);
        getDataList(value, categoryId)
    };

    const [categoryId, setCategoryId] = useState(null);

    const [dataList, setDataList] = useState(null)

    const [currentBg, setCurrentBg] = useState(null)


    async function getDataList(page, id) {
        setLoading(true)
        try {
            let res = await UserApi.nftRecordSearch({ page: page })
            console.log(res.data.data)
            setDataList(res.data.data)
            setTotalPage(res.data.total == 0 ? 1 : Math.ceil(res.data.total / 10))

        }
        catch (errors) {
            errorToast(errors?.response?.data?.message || errors.toString())
        }
        setLoading(false)

    }

    useEffect(() => {
        let id = query.get('categoryId')
        console.log(id)
        setCategoryId(id)

        if (id == 1){
            setCurrentBg(bg1Img)
        }
        else if (id == 2){
            setCurrentBg(bg2Img)
        }
        else if (id == 3){
            setCurrentBg(bg3Img)
        }
        else if (id == 4){
            setCurrentBg(bg4Img)
        }
        else{
            setCurrentBg(bg1Img)
        }


        // getDataList(1,id)
    }, [query.get('categoryId')]);


    return <div className="relative bg-white " >


        <div className="relative mx-auto w-11/12 sm:w-full rounded-b-[40px] sm:rounded-b-none h-[150px] sm:h-screen overflow-hidden">
            <img className="w-full h-full object-cover" src={categoryId && menuData && menuData.find(i => i.id == categoryId)?.image} />
            <img className=" absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-1/2 max-w-[80px] sm:max-w-[200px]  object-contain " src={logoImg} />
        </div >

        <div className=" w-full  session1 py-[30px] sm:py-[100px] text-black96 ">
            <div className="flex gap-10 justify-center sm:justify-start items-end  mb-7 ">
                <svg className="hidden sm:block" xmlns="http://www.w3.org/2000/svg" width="78" height="62" viewBox="0 0 78 62" fill="none">
                    <g clip-path="url(#clip0_526_9410)">
                        <path d="M23.1473 16.5465C23.2745 16.377 23.3316 16.1659 23.3068 15.9563C23.282 15.7466 23.1773 15.5542 23.014 15.4181L4.27408 0.267355C4.13704 0.163096 3.96738 0.10954 3.79454 0.115985V0H0V61.016H3.73087C3.75474 61.016 3.76867 61.0435 3.79454 61.0435C3.89941 61.0417 4.00288 61.0194 4.09902 60.978C4.19516 60.9366 4.28206 60.8768 4.35473 60.8021C4.4274 60.7274 4.4844 60.6392 4.52247 60.5426C4.56053 60.4461 4.57891 60.343 4.57653 60.2394V2.5556L22.0589 16.6861C22.1385 16.7502 22.2306 16.7975 22.3294 16.8252C22.4281 16.853 22.5316 16.8606 22.6335 16.8475C22.7353 16.8344 22.8334 16.801 22.9217 16.7493C23.0101 16.6975 23.0868 16.6285 23.1473 16.5465Z" fill="#463D3A" />
                        <path d="M77.5623 0.178867C77.4317 0.11221 77.2841 0.085052 77.138 0.100785C76.9918 0.116518 76.8536 0.174445 76.7406 0.26733L58.2812 15.194C58.118 15.3297 58.0134 15.5218 57.9886 15.7311C57.9638 15.9404 58.0208 16.1512 58.1479 16.3204C58.2084 16.4031 58.2853 16.4727 58.3741 16.5248C58.4629 16.5769 58.5615 16.6104 58.6639 16.6233C58.7663 16.6362 58.8703 16.6282 58.9695 16.5998C59.0686 16.5713 59.1608 16.5231 59.2403 16.458L73.4236 4.98929V61.0159H77.1544C77.1783 61.0159 77.1942 61.0435 77.2181 61.0435C77.3228 61.0414 77.4261 61.019 77.522 60.9774C77.6179 60.9359 77.7046 60.8761 77.777 60.8014C77.8495 60.7267 77.9063 60.6386 77.9442 60.5422C77.9822 60.4457 78.0005 60.3429 77.9981 60.2394V0.900333C77.9994 0.75216 77.9595 0.606485 77.8826 0.479241C77.8058 0.351996 77.695 0.248083 77.5623 0.178867Z" fill="#463D3A" />
                        <path d="M61.4032 51.8296C61.136 52.1615 60.7957 52.4288 60.4081 52.6111C60.0205 52.7933 59.5959 52.8858 59.1666 52.8813C57.9847 52.8813 56.8704 52.2653 55.8238 51.0334C54.7771 49.8015 53.7968 47.9497 52.8829 45.4779C53.7411 43.5632 54.5331 41.5521 55.2587 39.4447C55.9843 37.3374 56.629 35.1749 57.1928 32.9575L60.3347 20.2286H52.6401L49.6992 33.04C48.7043 28.381 46.9917 24.8863 44.5615 22.5562C42.1313 20.226 38.9961 19.0635 35.1558 19.0687C30.2675 19.0687 26.0379 21.0516 22.4668 25.0174C18.8958 28.9832 17.111 33.614 17.1123 38.91C17.1123 44.7905 18.8514 49.6514 22.3296 53.4927C25.8077 57.334 30.1647 59.2552 35.4005 59.2565C38.8389 59.2565 41.8269 58.4047 44.3645 56.7009C46.9022 54.9972 49.2594 52.245 51.4363 48.4444C52.4312 52.6552 53.4639 55.5103 54.5344 57.0096C55.0133 57.721 55.6674 58.3004 56.4353 58.6934C57.2031 59.0865 58.0594 59.2803 58.9239 59.2565C60.6709 59.2565 61.9736 58.4853 62.8318 56.9427C63.6901 55.4002 64.1192 53.0504 64.1192 49.8932V48.9791H62.5513C62.3881 50.1704 62.0054 51.1206 61.4032 51.8296ZM43.8174 52.9521C42.0186 55.6283 39.5506 56.9663 36.4133 56.9663C32.9511 56.9663 30.3126 55.4343 28.4979 52.3702C26.6832 49.3061 25.7732 44.8751 25.7679 39.0771C25.7679 33.7248 26.7283 29.4884 28.6491 26.3679C30.57 23.2475 33.1819 21.6873 36.485 21.6873C39.5466 21.6873 42.0305 22.9696 43.9367 25.5344C45.843 28.0992 47.401 32.3087 48.6108 38.163C47.2139 45.3449 45.6161 50.2746 43.8174 52.9521Z" fill="#463D3A" />
                    </g>
                    <defs>
                        <clipPath id="clip0_526_9410">
                            <rect width="78" height="61.0435" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
                <div className="flex flex-col sm:flex-row items-center sm:items-end gap-0 sm:gap-4">
                    <p className="text-3xl italic">{categoryId && menuData && menuData.find(i => i.id == categoryId)?.engName}</p>
                    <p className="text-base italic">{categoryId && menuData && menuData.find(i => i.id == categoryId)?.name}</p>
                </div>
            </div>
            <div className="mb-[60px] ">
                <p className="leading-[200%]">{categoryId && menuData && menuData.find(i => i.id == categoryId)?.description}</p>
            </div>

            {
                categoryId && menuData && menuData.find(i => i.id == categoryId)?.subcategories.map(subcategory =>
                    <div key={subcategory.id} className="mb-10">
                        <p className=" font-bold text-sm text-main1 mb-4 hidden sm:block">{subcategory.name}</p>
                        <div className="grid  grid-cols-1 sm:grid-cols-2  md:grid-cols-4 gap-6">
                            {
                                subcategory.products.map(i => <Link key={i.id} to={`/product/${i.id}`} className="w-full h-full  bg-white p-4 rounded-md shadow-me">
                                    <img className=" w-full aspect-[1/1] object-cover  rounded-md mb-4" src={i.images.length > 0 && i.images[0].image} />
                                    <p className="text-black1 text-center font-bold mb-1 sm:mb-5 ">{i.name}</p>
                                    <p className="text-black1 text-sm text-center font-bold mb-5 sm:hidden">{subcategory.name}</p>

                                    <p className="text-red1 text-center font-bold text-sm mb-1">NT$  {separatorNumber(i.price)}</p>

                                </Link>)
                            }

                        </div>
                    </div>
                )
            }

        </div >



    </div >
}

export default Home